/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svc_Protocol_HeadingInputs */

const en_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-STAGE DELIVERY PIPELINE`)
};

const ar_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خط تسليم من ${i?.count} مراحل`)
};

const bn_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-ধাপ ডেলিভারি পাইপলাইন`)
};

const de_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-STAGE DELIVERY PIPELINE`)
};

const es_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} - TUBO DE ENTREGA EN ETAPA`)
};

const fr_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-PIPELINE DE LIVRAISON PAR ÉTAPE`)
};

const pt_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Pipeline de entrega de estágio`)
};

const zh_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 阶段交付管道`)
};

const tr_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-AŞAMA TESLİMAT HATTI`)
};

const ru_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-ЭТАПНЫЙ ТРУБОПРОВОД ДОСТАВКИ`)
};

const pl_svc_protocol_heading = /** @type {(inputs: Svc_Protocol_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} – ETAP DOSTAWY`)
};

/**
* | output |
* | --- |
* | "{count}-STAGE DELIVERY PIPELINE" |
*
* @param {Svc_Protocol_HeadingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_protocol_heading = /** @type {((inputs: Svc_Protocol_HeadingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Protocol_HeadingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_protocol_heading(inputs)
	if (locale === "bn") return bn_svc_protocol_heading(inputs)
	if (locale === "de") return de_svc_protocol_heading(inputs)
	if (locale === "es") return es_svc_protocol_heading(inputs)
	if (locale === "fr") return fr_svc_protocol_heading(inputs)
	if (locale === "pt") return pt_svc_protocol_heading(inputs)
	if (locale === "zh") return zh_svc_protocol_heading(inputs)
	if (locale === "tr") return tr_svc_protocol_heading(inputs)
	if (locale === "ru") return ru_svc_protocol_heading(inputs)
	if (locale === "pl") return pl_svc_protocol_heading(inputs)
	return en_svc_protocol_heading(inputs)
});